export default __webpack_public_path__ + "static/media/i036vp.520422b8.webp";